/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_DueInputs */

const cs_deal_payments_due = /** @type {(inputs: Deal_Payments_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Splatnost`)
};

const en_deal_payments_due = /** @type {(inputs: Deal_Payments_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due`)
};

/**
* | output |
* | --- |
* | "Due" |
*
* @param {Deal_Payments_DueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_due = /** @type {((inputs?: Deal_Payments_DueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_DueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_due(inputs)
	return cs_deal_payments_due(inputs)
});